import React, { useState } from 'react';
import '../cssComponents/About.css';

import Logo from '../../assets/LOGO.png';
import Adamo from './Adamo';

const About = () => {

  const [sliderPosAngela, setSliderPosAngela] = useState(50);
  const [sliderPosHusky, setSliderPosHusky] = useState(50);
  const [sliderPosAdam, setSliderPosAdam] = useState(50);

  const handleSliderChangeAngela = (event) => {
    const newValue = event.target.value;
    setSliderPosAngela(newValue);
  }

  const handleSliderChangeHusky = (event) => {
    const newValue = event.target.value;
    setSliderPosHusky(newValue);
  }

  const handleSliderChangeAdam = (event) => {
    const newValue = event.target.value;
    setSliderPosAdam(newValue);
  }

  return (
    <div className="about">
      
      {/*<Adamo />*/}
      <img src={Logo} className="img-logo"></img>


      <h1>STRING ART</h1>
      <span></span>
      <p>La String Art è una raffinata tecnica artistica che trasforma linee geometriche in opere d'arte. Il processo ha inizio con una base lignea sulla quale vengono disposti con precisione i chiodi, definendo il perimetro dell'opera. Successivamente, attraverso un lavoro di intreccio manuale con un unico filo continuo, prendono vita forme, sfumature e volumi. Emozioni Intrecciate si pone l'obiettivo di reinterpretare questo artigianato tradizionale in chiave contemporanea. La nostra start-up è specializzata nella progettazione e realizzazione di opere uniche e su misura. Ogni pezzo è il risultato di ore di precisione millimetrica, il che garantisce l'assoluta irripetibilità di ogni creazione. Che si tratti di valorizzare uno spazio commerciale, un ufficio o un ambiente domestico, le nostre opere sono pensate per catturare l'attenzione e ridefinire il concetto di decorazione d'interni. Non creiamo semplici quadri, diamo forma alle vostre emozioni attraverso il filo.</p>
      
      

      <div className="about-slider-container">
        <div className="slider-image img-before" style={{clipPath: `polygon(0 0, ${sliderPosAngela}% 0, ${sliderPosAngela}% 100%, 0 100%)` }}></div>
        <div className="slider-image img-after"></div>
        <div className="slider-line" style={{left: `${sliderPosAngela}%` }}></div>
        <div className="slider-button" style={{left: `${sliderPosAngela}%` }}>

       
        <svg fill="#000000" width="30px" height="39px" viewBox="0 0 24 24" id="left-right-scroll-bar-2" className="icon line">
          <polyline
            id="primary"
            points="5 10 3 12 5 14"
            style={{
              fill: "none",
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.5,
            }}
          />

          <polyline
            id="primary-2"
            data-name="primary"
            points="19 14 21 12 19 10"
            style={{
              fill: "none",
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.5,
            }}
          />

          <path
            id="primary-3"
            data-name="primary"
            d="M12,6V18M8,12H3m13,0h5"
            style={{
              fill: "none",
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.5,
            }}
          />
        </svg>        

        </div>

        
        <input type="range" min="0" max="100" value={sliderPosAngela} className="slider" id="image-slider" onChange={handleSliderChangeAngela}></input>
      </div>

      <div className="about-slider-container">
        <div className="slider-image img-before husky" style={{clipPath: `polygon(0 0, ${sliderPosHusky}% 0, ${sliderPosHusky}% 100%, 0 100%)` }}></div>
        <div className="slider-image img-after husky"></div>
        <div className="slider-line" style={{left: `${sliderPosHusky}%` }}></div>
        <div className="slider-button" style={{left: `${sliderPosHusky}%` }}>

       
        <svg fill="#000000" width="30px" height="39px" viewBox="0 0 24 24" id="left-right-scroll-bar-2" className="icon line">
          <polyline
            id="primary"
            points="5 10 3 12 5 14"
            style={{
              fill: "none",
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.5,
            }}
          />

          <polyline
            id="primary-2"
            data-name="primary"
            points="19 14 21 12 19 10"
            style={{
              fill: "none",
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.5,
            }}
          />

          <path
            id="primary-3"
            data-name="primary"
            d="M12,6V18M8,12H3m13,0h5"
            style={{
              fill: "none",
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.5,
            }}
          />
        </svg>        

        </div>

        
        <input type="range" min="0" max="100" value={sliderPosHusky} className="slider" id="image-slider" onChange={handleSliderChangeHusky}></input>
      </div>

      <div className="about-slider-container">
        <div className="slider-image img-before adam" style={{clipPath: `polygon(0 0, ${sliderPosAdam}% 0, ${sliderPosAdam}% 100%, 0 100%)` }}></div>
        <div className="slider-image img-after adam"></div>
        <div className="slider-line" style={{left: `${sliderPosAdam}%` }}></div>
        <div className="slider-button" style={{left: `${sliderPosAdam}%` }}>

       
        <svg fill="#000000" width="30px" height="39px" viewBox="0 0 24 24" id="left-right-scroll-bar-2" className="icon line">
          <polyline
            id="primary"
            points="5 10 3 12 5 14"
            style={{
              fill: "none",
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.5,
            }}
          />

          <polyline
            id="primary-2"
            data-name="primary"
            points="19 14 21 12 19 10"
            style={{
              fill: "none",
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.5,
            }}
          />

          <path
            id="primary-3"
            data-name="primary"
            d="M12,6V18M8,12H3m13,0h5"
            style={{
              fill: "none",
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.5,
            }}
          />
        </svg>        

        </div>

        
        <input type="range" min="0" max="100" value={sliderPosAdam} className="slider" id="image-slider" onChange={handleSliderChangeAdam}></input>
      </div>
    </div>
  )
}

export default About;